import React from 'react';
import { ItineraryType } from 'gql/autogen/ItineraryType';
import { ItineraryReference } from 'gql/autogen/ItineraryReference';
import UnstructuredItinerary from 'component/page/detail/Itineraries/UnstructuredItinerary/UnstructuredItinerary';
import StructuredItinerary from 'component/page/detail/Itineraries/StructuredItinerary/StructuredItinerary';
import HopOnHopOffItinerary from 'component/page/detail/Itineraries/HopOnHopOffItinerary/HopOnHopOffItinerary';

const itineraryComponents: Record<ItineraryType, React.JSX.Element | null> = {
    [ItineraryType.STRUCTURED_ITINERARY]: <StructuredItinerary />,
    [ItineraryType.ROUTE_ITINERARY]: <HopOnHopOffItinerary />,
    [ItineraryType.UNSTRUCTURED_ITINERARY]: <UnstructuredItinerary />,
    [ItineraryType.UNKNOWN]: null,
};

const ItineraryContainer: React.FC<{ itinerary?: ItineraryReference }> = (props) => {
    if (!props.itinerary || !props.itinerary.itineraryType) {
        return null;
    }

    return <div data-testid="activities-what-to-expect-info">{itineraryComponents[props.itinerary.itineraryType]}</div>;
};
ItineraryContainer.displayName = 'ItineraryContainer';

export default ItineraryContainer;
